export enum DATA_QA {
  CANCEL = 'csv-rename__cancel',
  CONFIRM = 'csv-rename__confirm',
}
